import React, { useState, useEffect } from "react";
import {
  FormGroup,
  Row,
  Col,
  FormSelect,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "shards-react";
import styled from "styled-components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import Layout from "shared/container/LayoutAdmin";
import {
  SelectIndicatorsDatasetKeyin,
  SelectIndicatorsDatasetKeyinTabs,
  SelectIndicatorsDatasetKeyinYears,
  SelectAgencyPowerBi,
} from "shared/components";
import { Loading, KeyinAllTable } from "views/PowerbiSetting/components";
import useCurrentUser from "shared/hook/useCurrentUser";

const RowData = styled(Row)`
  margin-top: 10px;
  border-top: 1px solid #e1e5eb;
  padding-top: 20px;
`;

const showNotify = (message, type) => {
  switch (type) {
    case "success":
      toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case "error":
      toast.error(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case "warn":
      toast.warn(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case "info":
      toast.info(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    default:
      toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
  }
};

const PowerbiSettingKeyin = (props) => {
  const { token } = useToken();
  const { curruntUser } = useCurrentUser();
  const [userType, setUserType] = useState(0);
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [agencyId, setAgencyId] = useState(null);
  const [openAddyears, setOpenAddyears] = useState(false);
  const [indicatorsDatasetId, setIndicatorsDatasetId] = useState(null);
  const [tableTabSettingId, setTableTabSettingId] = useState(null);
  const [yearId, setyearId] = useState(null);
  const [yearNo, setyearNo] = useState(null);
  const [yearsInputId, setYearsInputId] = useState(null);
  const [yearsInput, setYearsInput] = useState([]);
  const [ yearList , setYearList ] = useState(null);
  const [indicatorsYearsList, setIndicatorsYears] = useState([]);
  const [newYearsList, setnewYears] = useState([]);

  const tableTabMasterId = [
    5,
    15,
    16,
    22,
    32,
    37,
    38,
    39,
    64,
    67,
    72,
    75,
    76,
    93,
    98,
    99,
    108,
    109,
  ];

  const axios = require("axios").default;

  const addYearsList = () => {
    const yearList = [...indicatorsYearsList];
    const yearNewsList = [...newYearsList];
    const currentYears = yearList.map((item) => {
      return item.yearId;
    });
    if (!currentYears.includes(yearsInputId)) {
      const yearListSort = yearList.concat(yearsInput).sort(function(a, b) {
        return a.yearId - b.yearId;
      });
      setIndicatorsYears(yearListSort);
      setnewYears(yearNewsList.concat([yearsInputId]));
      setTimeout(() => {
        setyearId(yearsInputId);
      }, 500);
    }

    setOpenAddyears(false);
    setYearsInputId(0);
    setYearsInput([]);
  };

  const checkNewYears = () => {
    const yearNewsList = [...newYearsList];
    const currentYears = yearNewsList.map((item) => {
      return item.yearId;
    });
    return currentYears.includes(yearId);
  }

  const getIndicatorsYears = () => {
    var data = JSON.stringify({
      indicatorsDatasetSettingId: indicatorsDatasetId,
      tableTabSettingId: tableTabSettingId,
    });
    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/yeargroupheadtable`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        const result = Object.keys(response.data).map(key => response.data[key].yearNo);
        const filterYear =  yearList.filter(item => {
            if(result.includes(item.yearNo)){
              return item;
            }
          });
        setIndicatorsYears(filterYear);
      })
      .catch(function(error) {
        console.log("/v1/setting-table/yeargroupheadtable", error);
      });
  };

  const getYearList = () => {
    const axios = require("axios").default;
    var data = JSON.stringify({
      "show": 100,
      "page": 1,
      "orderBy": "yearId",
      "orderType": "DESC"
    });
 
    var config = {
      method: 'post',
      url: `${baseUrl}/v1/setting-table/listyear`,
      headers: { 
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json'
      },
      data : data
    };
    axios(config).then(function (response) {
      setYearList(response.data.data);
    })
    .catch(function (error) {
      console.log("setting-table/listyear",error);
    });
  };

  //4 สร้างข้อมูลเพื่อส่งไปอนุมัติ
  const onCeateTable = (dataImport) => {
    var data = JSON.stringify({
      indicatorsDatasetSettingId: indicatorsDatasetId,
      yearId: yearId,
      agencyId: agencyId,
      tableTabSettingId: tableTabSettingId,
      create: dataImport,
    });
    var config = {
      method: "post",
      url: `${baseUrl}/v1/table${indicatorsDatasetId}/create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        setAgencyId(0);
        setIndicatorsDatasetId(0);
        setTableTabSettingId(0);
        setyearId(0);
        setyearNo(null);
        setLoading(false);
        showNotify("แจ้งเตือน! บันทึกข้อมูลเรียบร้อย");
      })
      .catch(function(error) {
        console.log(`${baseUrl}/v1/table${indicatorsDatasetId}/create`, error);

        if(error.response.data.message){
          showNotify(error.response.data.message, "error");
        }else{
          showNotify(error.message, "error");
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    getYearList();
    getIndicatorsYears();
  }, [indicatorsDatasetId, tableTabSettingId]);

  useEffect(() => {
    if (curruntUser) {
      setUserType(curruntUser.detail.userType);
      setAgencyId(curruntUser.detail.agencyId);
      setUserId(curruntUser.detail.userId);
    }
  }, [curruntUser]);

  return (
    <Layout>
      <ToastContainer />
      {loading && <Loading />}
      <Row>
        <Col md="12">
          <h5 style={{ marginBottom: "30px" }}>กรอกข้อมูลผ่านระบบ(Key-in)</h5>
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormGroup>
            <label>
              หน่วยงานเจ้าของข้อมูล<span style={{ color: "red" }}>*</span>
            </label>
            <SelectAgencyPowerBi
              placeholder="เลือก"
              name="agencyId"
              onChange={(e) => {
                setAgencyId(e.target.value);
                setIndicatorsDatasetId(0);
                setyearId(0);
              }}
              defaultValue={agencyId}
              value={agencyId}
              userId={userType == 3 || userType == 4 ? userId : null}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <label>
              ข้อมูล/ตัวชี้วัด<span style={{ color: "red" }}>*</span>
            </label>
            <SelectIndicatorsDatasetKeyin
              placeholder="เลือก"
              disabled={agencyId == null || agencyId == 0}
              name="indicatorsDatasetId"
              onChange={(e) => {
                setIndicatorsDatasetId(e.target.value);
                setTableTabSettingId(0);
                setyearId(0);
              }}
              agencyId={agencyId}
              defaultValue={indicatorsDatasetId}
              value={indicatorsDatasetId}
              userId={userType == 3 || userType == 4 ? userId : null}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <label>ชื่อชุดข้อมูล</label>
            <SelectIndicatorsDatasetKeyinTabs
              placeholder="เลือก"
              name="indicatorsDatasetSettingId"
              disabled={
                agencyId == null ||
                indicatorsDatasetId == null ||
                agencyId == 0 ||
                indicatorsDatasetId == 0
              }
              onChange={(e) => {
                setTableTabSettingId(e.target.value);
                setyearId(0);
              }}
              agencyId={agencyId}
              indicatorsDatasetSettingId={indicatorsDatasetId}
              defaultValue={tableTabSettingId}
              value={tableTabSettingId}
            />
          </FormGroup>
        </Col>
      </Row>
      {tableTabMasterId.indexOf(Number(tableTabSettingId)) !== -1 || indicatorsDatasetId == 17 ? null : (
        <Row>
          <Col md="4">
            <FormGroup>
              <label>
                เลือกปี พ.ศ.<span style={{ color: "red" }}>*</span>
              </label>
              <FormSelect
                placeholder="เลือก"
                name="yearId"
                disabled={
                  agencyId == null ||
                  indicatorsDatasetId == null ||
                  agencyId == 0 ||
                  indicatorsDatasetId == 0 ||
                  tableTabSettingId == null ||
                  tableTabSettingId == 0
                }
                onChange={(e) => {
                  setyearId(e.target.value);
                  setyearNo(e.target.options[e.target.selectedIndex].text);
                }}
                defaultValue={yearId}
                value={yearId}
              >
                <option value="0">-เลือก-</option>
                {indicatorsYearsList != null &&
                  indicatorsYearsList.length > 0 &&
                  indicatorsYearsList.map((item, key) => (
                    <option key={key} value={item.yearId} title={item.yearNo}>
                      {item.yearNo}
                    </option>
                  ))}
              </FormSelect>
            </FormGroup>
          </Col>
          {agencyId == null ||
          indicatorsDatasetId == null ||
          agencyId == 0 ||
          indicatorsDatasetId == 0 ||
          tableTabSettingId == null ||
          tableTabSettingId == 0 ? null : (
            <Col md="4" style={{ paddingTop: 30 }}>
              <Button
                outline
                theme="light"
                style={{ color: "#007bff" }}
                onClick={() => setOpenAddyears(!openAddyears)}
              >
                {" "}
                + เพิ่มปี พ.ศ.{" "}
              </Button>
            </Col>
          )}

          <Modal
            open={openAddyears}
            toggle={() => setOpenAddyears(!openAddyears)}
          >
            <ModalHeader>เพิ่มปี พ.ศ.</ModalHeader>
            <ModalBody>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <label>ระบุ พ.ศ.ที่ต้องการเพิ่ม*</label>
                    <SelectIndicatorsDatasetKeyinYears
                      placeholder="เลือก"
                      name="yearsInputId"
                      onChange={(e) => {
                        setYearsInputId(e.target.value);
                        setYearsInput([
                          {
                            yearId: e.target.value,
                            yearNo: e.target.options[e.target.selectedIndex].text,
                            yearNoAD: Number(e.target.options[e.target.selectedIndex].text) - 543,
                          },
                        ]);
                      }}
                      indicatorsYearsList={indicatorsYearsList}
                      defaultValue={yearsInputId}
                      value={yearsInputId}
                      openAddyears={openAddyears}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button
                outline
                theme="secondary"
                onClick={() => setOpenAddyears(!openAddyears)}
              >
                {" "}
                ยกเลิก{" "}
              </Button>
              <Button
                theme="success"
                disabled={yearsInput == null}
                onClick={() => {
                  if (yearsInput !== null) {
                    addYearsList();
                  }
                }}
              >
                บันทึก
              </Button>
            </ModalFooter>
          </Modal>
        </Row>
      )}
      
      {/* start data */}
      {agencyId != null &&
      agencyId != 0 &&
      indicatorsDatasetId != null &&
      indicatorsDatasetId != 0 &&
      tableTabSettingId != null &&
      tableTabSettingId != 0 ? (
        tableTabMasterId.indexOf(Number(tableTabSettingId)) !== -1 || indicatorsDatasetId == 17 ? (
          <RowData>
            <KeyinAllTable
              type="new"
              tableTabSettingId={tableTabSettingId}
              indicatorsDatasetSettingId={indicatorsDatasetId}
              yearId={yearId}
              yearNo={yearNo}
              agencyId={agencyId}
              newHeadId={checkNewYears()}
              onCeateTable={(sendData) => onCeateTable(sendData)}
              tableTabMaster={
                tableTabMasterId.indexOf(Number(tableTabSettingId)) !== -1
              }
            />
          </RowData>
        ) : yearId != null && yearId != 0 ? (
          <RowData>
            <KeyinAllTable
              type="new"
              tableTabSettingId={tableTabSettingId}
              indicatorsDatasetSettingId={indicatorsDatasetId}
              yearId={yearId}
              yearNo={yearNo}
              agencyId={agencyId}
              newHeadId={checkNewYears()}
              onCeateTable={(sendData) => onCeateTable(sendData)}
              tableTabMaster={
                tableTabMasterId.indexOf(Number(tableTabSettingId)) !== -1
              }
            />
          </RowData>
        ) : (
          <RowData>
            <Col md="12">
              <p style={{ textAlign: "center" }}>
                กรุณาเลือก ตัวชี้วัด และ ปี ที่ต้องการนำเข้าข้อมูล{" "}
              </p>
            </Col>
          </RowData>
        )
      ) : (
        <RowData>
          <Col md="12">
            <p style={{ textAlign: "center" }}>
              กรุณาเลือก ตัวชี้วัด ที่ต้องการนำเข้าข้อมูล{" "}
            </p>
          </Col>
        </RowData>
      )}
    </Layout>
  );
};

export default PowerbiSettingKeyin;
